import { AppLayout, AppHeader, AppFooter } from 'components/index';

export function AuthenticatedLayout() {
  return <AppLayout header={<AppHeader />} footer={<AppFooter />} />;
}
